module.exports = __webpack_public_path__ + "static/media/subGoogle1.cf79d0e4.png";